module.exports = __webpack_public_path__ + "img/gongzonghao.d4426809.png";